import React from 'react';
import { Link } from 'react-router-dom';

export default function ContactTheBrandRecorder({ inDialog }) {
  return (
    <>
      <h4>Have a Question?</h4>
      Please contact, <strong>Suzanne Butler</strong><br /><br />
      <a href="mailto:sbutler@utah.gov">sbutler@utah.gov</a><br />
      {inDialog && <br />}
      <strong><a href="tel:801-982-2240">(801) 982-2240</a></strong><br /><br />
      {!inDialog && <span><Link to="/help" data-id="BB2xt">Back to Help</Link><br /></span>}
    </>
  );
}